import { Component, Inject, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-landing-rtk-base-analyzer',
  templateUrl: './landing-rtk-base-analyzer.component.html',
  styleUrls: ['../landing/landing.component.scss', './landing-rtk-base-analyzer.component.scss']
})
export class LandingRtkBaseAnalyzerComponent implements OnInit {

  constructor(private title: Title, private meta: Meta, @Inject(DOCUMENT) private doc: Document, private auth: AuthService) {}

  ngOnInit(): void {
    const CANON = 'https://geoastra.com';
    const url = `${CANON}/landing-rtk-base-analyzer`;
    this.title.setTitle('RTK Base Analyzer — GeoAstra');
    this.meta.updateTag({ name: 'description', content: 'Analyze your RTK base data quality, visualize sessions, and improve reliability with GeoAstra RTK Base Analyzer.' });
    this.meta.updateTag({ property: 'og:title', content: 'RTK Base Analyzer — GeoAstra' });
    this.meta.updateTag({ property: 'og:description', content: 'Analyze and visualize RTK base sessions and quality.' });
    this.meta.updateTag({ property: 'og:url', content: url });
    this.meta.updateTag({ property: 'og:type', content: 'product' });
    this.meta.updateTag({ property: 'og:image', content: 'https://geoastra.com/assets/images/landing/GeoAstra_NTRIP.png' });
    this.meta.updateTag({ name: 'twitter:card', content: 'summary_large_image' });
    this.meta.updateTag({ name: 'twitter:title', content: 'RTK Base Analyzer — GeoAstra' });
    this.meta.updateTag({ name: 'twitter:description', content: 'Visualize and analyze your RTK base sessions.' });
    this.meta.updateTag({ name: 'twitter:image', content: 'https://geoastra.com/assets/images/landing/GeoAstra_NTRIP.png' });
    let link: HTMLLinkElement | null = this.doc.querySelector("link[rel='canonical']");
    if (!link) { link = this.doc.createElement('link'); link.setAttribute('rel', 'canonical'); this.doc.head.appendChild(link); }
    link.setAttribute('href', url);
  }

  login(): void { this.auth.login(); }
  signup(): void { this.auth.signup(); }
  redirectToEnterPrise() { window.location.href = 'https://gpswebshop.com/products/geoastra-ntrip-caster-enterprise-edition-12-month-subscription-service?variant=47996976169268'; }
  redirectToPro() { window.location.href = 'https://gpswebshop.com/products/geoastra-ntrip-caster-pro-edition-1-month-subscription-service?variant=47997022535988'; }
}